import { render, staticRenderFns } from "./shop_import_process.vue?vue&type=template&id=c25c230a&scoped=true&"
import script from "./shop_import_process.vue?vue&type=script&lang=ts&"
export * from "./shop_import_process.vue?vue&type=script&lang=ts&"
import style0 from "./shop_import_process.vue?vue&type=style&index=0&id=c25c230a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25c230a",
  null
  
)

export default component.exports